import Axios from "axios";

// Processos do Siga visíveis ao usuário, compartilhados pelos botões "Tutorial" das telas.
const VALIDADE_MS = 5 * 60 * 1000;
let cache = null;

export function carregarProcessosDisponiveis() {
  const agora = Date.now();
  if (cache && agora - cache.carregadoEm < VALIDADE_MS) {
    return cache.promessa;
  }
  const promessa = Axios.get("tutorials/available")
    .then((response) => response.data || [])
    .catch(() => {
      cache = null;
      return [];
    });
  cache = { promessa, carregadoEm: agora };
  return promessa;
}

export function limparProcessosDisponiveis() {
  cache = null;
}
